import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { MyCompany } from "../../graphql/graphql_information/company/types/MyCompany";

export const informationSlice = createSlice({
  name: "information",
  initialState: {
    myInformation: {} as MyCompany,
  },
  reducers: {
    setMyInformation: (state, action: PayloadAction<MyCompany>) => {
      state.myInformation = action.payload;
    },
  },
});

export const { setMyInformation } = informationSlice.actions;

export default informationSlice.reducer;
